export default "__VITE_ASSET__C$gqrQzC__"